import { Stack } from '@mui/material';
import CategoryCard from '@pages/CategoriesListPage/components/CategoryCard';
import { CategoriesListStyles } from '@pages/CategoriesListPage/styles';
import ProductList from '@partful/pages/product-library/ui/product-list';
import type { ProductListAPIResponse } from '@partful/shared-types';
import { Job } from '@providers/job/types';
import { productCategoryPathEnumerationSeparator } from 'src/utils/urls';
import { filterUncategorizedProducts } from '../../../product-list/jobFiltering';

interface CategoriesListProps {
  categoriesToShow: string[]; // use real shared types
  decodedPathEnumeration: string;
  configurations: ProductListAPIResponse;
  jobs: Job[];
}

export function List({
  categoriesToShow,
  decodedPathEnumeration,
  configurations,
  jobs,
}: Readonly<CategoriesListProps>) {
  // we are not at lowest level category here, only show uncategorized products
  const uncategorizedConfigurations = filterUncategorizedProducts(configurations ?? /* istanbul ignore next */ []);

  return (
    <Stack direction="column" spacing="2rem">
      <ProductList configurations={uncategorizedConfigurations} jobs={jobs} />

      <CategoriesListStyles>
        {categoriesToShow.map((category) => (
          <CategoryCard
            key={category}
            categoryOfProducts={category}
            thumbnailUrl={determineThumbnailURL(configurations, decodedPathEnumeration, category)}
            decodedPathEnumeration={decodedPathEnumeration}
          />
        ))}
      </CategoriesListStyles>
    </Stack>
  );
}

const determineThumbnailURL = (
  products: ProductListAPIResponse,
  decodedPathEnumeration: string,
  currentCategory: string
) => {
  /* istanbul ignore next */
  if (!products) {
    return '/';
  }

  const thumbnailUrl = products.find((product) =>
    product.productCategories?.find(
      /* istanbul ignore next */ (categoryEnumeration) =>
        categoryEnumeration.includes(
          decodedPathEnumeration
            ? `${decodedPathEnumeration}${productCategoryPathEnumerationSeparator}${currentCategory}`
            : currentCategory
        )
    )
  )?.thumbnailUrl; // get first thumbnail of product category

  return thumbnailUrl ?? /* istanbul ignore next */ '/';
};
